const types = {
    AUTOSAVE_ON : 'AUTOSAVE_ON',
    AUTOSAVE_OFF: 'AUTOSAVE_OFF',
    AUTOSAVE_SET: 'AUTOSAVE_SET',
};

export default types;
